// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import Modal from 'app/components/commons/Modal';
import Button from 'app/components/commons/Button';
import Spinner from 'app/components/commons/Spinner';

type Props = {
  isLoading?: boolean,
  onCancel: () => void,
  onSubmit: (id?: number) => void,
  title: string,
  label: string
};

const defaultProps = {
  isLoading: false
};

const ButtonContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

const Content = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  fontSize: theme.fontSize.medium,
  marginBottom: theme.spacing.medium
}));

function ConfirmModal({ isLoading, label, onCancel, onSubmit, title }: Props) {
  return (
    <Modal isOpen onCancel={onCancel} size="small">
      <Content>
        <h3>{title}</h3>
      </Content>
      <ButtonContainer>
        <Button block kind="cancel" onClick={onCancel}>
          Cancel
        </Button>
        <Button block kind="primary" onClick={onSubmit} disabled={isLoading}>
          <div className="buttonInner">
            {isLoading && <Spinner inlineLeft />}
            <span>{isLoading ? 'Submitting...' : label}</span>
          </div>
        </Button>
      </ButtonContainer>
    </Modal>
  );
}

ConfirmModal.defaultProps = defaultProps;

export default ConfirmModal;
